import React, { useState } from 'react';
import SwiperCore, { Mousewheel, Scrollbar } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import PropTypes from 'prop-types';

import JBImage from 'components/essentials/JBImage';
import 'swiper/swiper-bundle.min.css';

SwiperCore.use([Mousewheel, Scrollbar]);

const ConsumerPressSlider = ({ config }) => {
  const [activeItemIndex, setActiveItemIndex] = useState(0);
  const { title, textImages } = config;
  const activeItem = textImages[activeItemIndex];

  const textImageList = textImages
    ? textImages.map((item, idx) => (
        <button
          type="button"
          key={item.text}
          className="items-center [background:none] border-0 flex flex-1 justify-center px-0 py-2.5 hover:cursor-pointer hover:underline focus-visible:outline-offset-[-2px]"
          onClick={() => setActiveItemIndex(idx)}
        >
          <div
            className={
              activeItem === item
                ? 'text-gray-light1 font-bold max-[600px]:[border-bottom:none]'
                : ''
            }
          >
            {item.text}
          </div>
        </button>
      ))
    : [];

  return (
    <div>
      {title && (
        <div
          className="text-[1.75rem] font-bold tracking-[-.75px] leading-[1.2] text-center mt-0 mx-auto mb-8"
          style={title.style}
        >
          {title.name.split('\n').map(it => (
            <h2 key={it}>{it}</h2>
          ))}
        </div>
      )}
      <Swiper
        freeMode
        mousewheel={{
          forceToAxis: true,
        }}
        scrollbar={{ draggable: true }}
        className="PressCarousel__items"
        breakpoints={{
          320: {
            slidesPerView: 2.5,
            spaceBetween: 30,
          },
          480: {
            slidesPerView: 3.5,
            spaceBetween: 30,
          },
          640: {
            slidesPerView: 4.5,
            spaceBetween: 40,
          },
          1024: {
            slidesPerView: 5.5,
            spaceBetween: 50,
          },
          1440: {
            slidesPerView: 6.5,
            spaceBetween: 60,
          },
        }}
      >
        {textImageList.map(child => (
          <SwiperSlide className="items-center flex justify-center mb-2.5 text-center">
            {child}
          </SwiperSlide>
        ))}
      </Swiper>

      {activeItem && activeItem.imgProps && (
        <div className="max-w-[70%] mt-20 mx-auto mb-0 text-center max-[600px]:mt-8">
          <JBImage {...activeItem.imgProps} />
        </div>
      )}
    </div>
  );
};

ConsumerPressSlider.propTypes = {
  config: PropTypes.shape({
    title: PropTypes.shape({
      name: PropTypes.string,
      style: PropTypes.object,
    }),
    textImages: PropTypes.arrayOf(
      PropTypes.shape({
        text: PropTypes.string,
        imgProps: PropTypes.shape({
          src: PropTypes.string,
          height: PropTypes.number,
        }),
      })
    ),
  }),
};

export default ConsumerPressSlider;
